import _ from 'lodash';
import React from 'react';
import { HelpBlock, Row } from '../../common/form';
import FundContext from './context';
import formatErrors from '../../shared/format';

export default function Errors() {
  const { state: { errors } } = React.useContext(FundContext);

  const showables = formatErrors(errors);

  if (_.isEmpty(showables)) {
    return null;
  }

  return (
    <>
      {showables.map(({ error, key }) => (
        <Row key={key}>
          <HelpBlock>{error}</HelpBlock>
        </Row>
      ))}
    </>
  );
}
